import { createSlice } from "@reduxjs/toolkit";

export interface VesselEmail {
  vesselId: number;
  rating: string;
  email: string;
}

interface VesselEmailState {
  vesselEmails: Record<number, VesselEmail[]>;
  loading: boolean;
  error: string | null;
}

const initialState: VesselEmailState = {
  vesselEmails: {},
  loading: false,
  error: null,
};


const vesselEmailSlice = createSlice({
  name: "vesselEmail",
  initialState,
  reducers: {
    setVesselEmails: (state, action) => {
      state.vesselEmails = action.payload.reduce(
        (acc: Record<number, VesselEmail[]>, item: any) => {
          const vesselId = item.vessel?.id;
          if (!vesselId) return acc; // skip invalid entries

          const vesselEmail: VesselEmail = {
            vesselId,
            rating: item.rating,
            email: item.email,
          };

          if (!acc[vesselId]) acc[vesselId] = [];
          acc[vesselId].push(vesselEmail);
          return acc;
        },
        {}
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addDefaultCase((state) => state);
  },
});

export const selectEmailsByVessel = (vesselId: number) => (state: any) =>
    state.vesselEmail.vesselEmails[vesselId] || [];

export const selectEmailsByVesselAndRating = (vesselId: number, rating: string) => (state: any) =>
    (state.vesselEmail.vesselEmails[vesselId] || [])
      .filter((e: VesselEmail) => e.rating === rating)
      .map((e: VesselEmail) => e.email);

export const selectAllVesselEmails = (state: any) =>
  state.vesselEmail.vesselEmails;

export default vesselEmailSlice.reducer;
